"use strict";
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ErrorBoundary = void 0;
var _react = require("react");
var _InternalErrorBoundary = require("./internal/InternalErrorBoundary");
var _loggerContext = require("./loggerContext");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * ErrorBoundary component that wraps around the provided children and handles any errors that occur within it.
 * It uses a logger to log the errors to Application Insights and provides a fallback UI in case of an error.
 * It will try to detect the logger from the context if no logger is provided in the parameters.
 *
 * @param {ReactNode} fallback The fallback to be displayed in case of an error - can be a component, or a function returning a component.
 * @param {string} areaName The name of the area for which the logger is created.
 * @param {ChildLogger} logger The logger instance to be used for logging errors.
 * @returns {JSX.Element} The rendered ErrorBoundary component.
 * @throws If no logger was provided in the parameters or detected in the context.
 */ var ErrorBoundary = function(_param) {
    var children = _param.children, fallback = _param.fallback, rest = _object_without_properties(_param, [
        "children",
        "fallback"
    ]);
    var areaName = 'areaName' in rest ? rest.areaName : undefined;
    var paramLogger = 'logger' in rest ? rest.logger : undefined;
    var parentLogger = (0, _react.useContext)(_loggerContext.loggerContext);
    var logger = (0, _react.useMemo)(function() {
        if (paramLogger) {
            return paramLogger;
        }
        if (areaName && parentLogger) {
            return parentLogger.createChild(areaName);
        }
        throw new Error('No logger was provided in the parameters or detected in the context');
    }, [
        paramLogger,
        areaName,
        parentLogger
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_InternalErrorBoundary.InternalErrorBoundary, {
        logger: logger,
        fallback: fallback,
        children: children
    });
};
exports.ErrorBoundary = ErrorBoundary; //# sourceMappingURL=ErrorBoundary.js.map
